import type { AttachmentDetails, EvidenceSessionAIModel } from 'api';
import { logger } from 'monitor';
import { Alert, DataCard } from 'ui';
import { Insights } from 'ui/icons';

import { EVIDENCE_SESSION_AI_MODEL_LABEL_MAP } from '../../constants';
import { AttachmentDetailsBreakdown } from '../../index';

type Props = {
  targetWeightPercentage?: number;
  attachmentDetails?: AttachmentDetails;
  isLoading: boolean;
  aiModel: EvidenceSessionAIModel;
  showAerosol?: boolean;
};

export const AttachmentDetailsDataCard = ({
  targetWeightPercentage,
  attachmentDetails,
  isLoading,
  aiModel,
  showAerosol = true,
}: Props) => {
  if (!attachmentDetails || !targetWeightPercentage) {
    if (attachmentDetails || targetWeightPercentage) {
      logger.error(
        'We must have both attachmentDetails and targetWeightPercentage if at least one of them is defined.'
      );
    }
    return <Alert severity="info">AI Weight Analysis not found</Alert>;
  }

  const title = `AI ${EVIDENCE_SESSION_AI_MODEL_LABEL_MAP[aiModel]} Weight Analysis`;

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          avatar: <Insights />,
          title: title,
        },
      }}
    >
      <DataCard.Item colSpan={12}>
        <AttachmentDetailsBreakdown
          attachmentDetails={attachmentDetails}
          targetWeightPercentage={targetWeightPercentage}
          showAerosol={showAerosol}
        />
      </DataCard.Item>
    </DataCard>
  );
};
